/** The ops module's part of the admin dashboard: a stopped worker and failed background jobs. */

import { useQuery } from "@tanstack/react-query";

import { adminJobsHealthRetrieve } from "@motolynk/api-client";
import { DashboardTask } from "@motolynk/app-core";
import { useTranslation } from "@motolynk/i18n";

import { jobKeys } from "./JobsPage";

export function JobTasks() {
  const { t } = useTranslation("ops");
  const health = useQuery({
    queryKey: jobKeys.health(),
    queryFn: async () => (await adminJobsHealthRetrieve()).data,
    refetchInterval: 60_000,
  });
  const h = health.data;
  return (
    <>
      <DashboardTask
        to="/system/jobs"
        icon="alert"
        label={t("workerDown")}
        count={h && !h.worker.alive ? 1 : 0}
        tone="danger"
      />
      <DashboardTask
        to="/system/jobs"
        icon="refresh"
        label={t("failedJobs")}
        count={h?.failed}
        tone="danger"
      />
    </>
  );
}
